// i18next-free and React-free, so boot code (session verification, the
// recruiter language switch) can share it without pulling either in.

/** What withTimeout resolves to when the promise did not settle in time. */
export const TIMED_OUT: unique symbol = Symbol('timedOut');

export type TimedOut = typeof TIMED_OUT;

/**
 * Resolves with the promise's value, or with TIMED_OUT once `timeoutMs`
 * passes first. A rejection that arrives in time passes through. The timer is
 * cleared when the promise settles, so a fast promise leaves nothing pending.
 */
export const withTimeout = <T>(
  promise: Promise<T>,
  timeoutMs: number
): Promise<T | TimedOut> =>
  new Promise<T | TimedOut>((resolve, reject) => {
    const timer = setTimeout(() => resolve(TIMED_OUT), timeoutMs);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
